import { currentDateTimeUtc } from "core/datetime";
import { isNil } from "lodash";
import { useFetchPostV2 } from "hooks/fetch/useFetchPostV2";
import { usePromise } from "react-use";

export default function useSaveCaseStatus(caseId) {
  const mounted = usePromise();

  const {
    loading: caseStatusSaving,
    error: caseStatusSaveError,
    postCallback: postNewCaseStatus
  } = useFetchPostV2("case_status", isNil(caseId));

  const saveCaseStatus = async newCaseStatus => {
    try {
      await mounted(
        postNewCaseStatus({
          case: caseId,
          status: newCaseStatus,
          date_time: currentDateTimeUtc()
        })
      );
    } catch (error) {
      console.error(error);
    }
  };

  return {
    saveCaseStatus,
    caseStatusSaving,
    caseStatusSaveError
  };
}
